import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IFingerEnroll } from '../interfaces/finger.enroll';
import { switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { StorageService } from './storage.service';
import { SearchEnrollmentRequest } from '../domain/model/search/search-enrollment-request';
import { Metadata } from '../base/model/data-body-request';


@Injectable({
  providedIn: 'root'
})
export class BidService {

  urlServices = environment.urlService; 
  authToken = environment.authToken
  ambiente = environment.urlServiceCommon
  bearerToken;

  constructor(private http: HttpClient, private storageService: StorageService) {
    //this.getT();
  }

  async getT() {
    console.log("getToken...1");
    this.bearerToken = await this.storageService.getStorageSync('TOKENJAVA');
    console.log("bearerToken", this.bearerToken);
  }

  operation(dataOperation: any) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/operation`, dataOperation, options);
  }

  getToken() {
    console.log("getToken...");

    /* let httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + 'dXNlcmFwcDpwYXNzd29yZA=='
      }),
    }; */

    const httpOptions = {
      headers: new HttpHeaders()
        .set('Authorization', 'Basic dXNlcmFwcDpwYXNzd29yZA==')
        .set('Content-type', 'application/x-www-form-urlencoded'),
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic dXNlcmFwcDpwYXNzd29yZA=='
    });
    const options = { headers };

    console.log("httpOptions", httpOptions);


    let params = 'grant_type=' + "password" +
      '&username=' + this.authToken +
      '&password=' + "password";

    return this.http.post(this.ambiente + "/uaa/oauth/token", params, options);
  }

  getToken2() {

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/json',
        'Authorization': 'Basic ' + 'dXNlcmFwcDpwYXNzd29yZA=='
      }),
    };

    let asyncResult;
    this.http.post<any>(this.ambiente + '/uaa/oauth/token?grant_type=password&username=tmv&password=password', httpOptions).toPromise().then(
      data => {
        asyncResult = data;
      }
    ).catch(
      error => {
        console.log('token error', error);
        asyncResult = null;
      }
    );
    console.log("asyncResult", asyncResult);

    return asyncResult;
  }

  contadorT(idT, opId, userId, tokenJava, component, metadataRequest: Metadata) {
    // this.bearerToken = await this.storageService.getStorageSync('TOKENJAVA');
    console.log("bearerTokenJ: ", tokenJava);
    let data = {
      "operationId": opId,
      "metadata": metadataRequest,
      "data": {
        "transaction": idT,
        "origin": "DW",
        "component": component,
        "status": "OK",
        "data": "{\"infoT\":\"DealerWeb\"}",
        "remark": ""
      }
    }

    console.log("dataCounT.-.-: ", data);

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + tokenJava
      }),
    };

    return this.http.post( this.ambiente + "/bid/rest/v1/biometricComponent", data);


  }

  getContratsJava(opId, nombreFirma, rfc, mail, b64) {
    // this.bearerToken = await this.storageService.getStorageSync('TOKENJAVA');
   // console.log("bearerTokenJ: ", tokenJava);
    let tokenJava = "";
    let data = {
      "operationId": opId,
      "data": {
        "codeContract": "AV_CONSENT",
        "documentType": "1",

        "campos": [
          {
            "nombre": "nombreFirma",
            "valor": nombreFirma
          },
          {
            "nombre": "RFC",
            "valor": rfc
          },
          {
            "nombre": "MAIL",
            "valor": mail
          },
          {
            "nombre": "firmaAnexoImg",
            "valor": b64
          }
        ],
        "data": "{\"infoT\":\"DealerWeb\"}",

      }
    }

    console.log("dataCounT.-.-: ", data);

    let httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/json',
        'Authorization': 'Bearer ' + tokenJava
      }),
    };

    return this.http.post(this.ambiente + "/bid/rest/v2/contracts/getContract2", data);


  }

  validateEmail(dataValidateEmail: any) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/enrollment/validate/email`, dataValidateEmail, options);

  }

  validateEmailExist(email: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.get(`${this.urlServices}/person?email=${email}`, options);

  }

  updateOperation(operationId: string, dataOperation: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.put(`${this.urlServices}/operation/${operationId}`, dataOperation, options);
  }

  updatePerson(personID: string, dataOperation: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.put(`${this.urlServices}/person/${personID}`, dataOperation, options);
  }

  createPerson(dataPerson: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/person`, dataPerson, options);
  }

  getContracts2(dataPerson: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/person`, dataPerson, options);
  }

  enrollFinger(dataFinger: IFingerEnroll) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/enrollment/biometric/finger/enroll`, dataFinger, options);

  }

  Ocr(dataOcr) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };

    return this.http.post(`${this.urlServices}/enrollment/extract/ocr/id`, dataOcr, options);
  }

  login(username: string, password: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    const dataLogin = {
      username,
      password
    };
    return this.http.post(`${this.urlServices}/user/login`, dataLogin, options).pipe(
      switchMap(async (data: any) => {

        this.storageService.saveToStorage('dataLogin', JSON.stringify(data)).then();
        this.storageService.saveToStorage('originalOperationId', data.originalOperationId).then();
        this.storageService.saveToStorage('type', 'register').then();
        this.storageService.saveToStorage('personIdRegister', data.personId).then();
        this.storageService.saveToStorage('oauthUserId', data.id).then();
        return from(this.storageService.saveToStorage('TOKEN', data.token));
      }));
  }

  startSession(username: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    const dataLogin = {
      username
    };
    return this.http.post(`${this.urlServices}/user/start-session`, dataLogin, options).pipe(
      switchMap(async (data: any) => {
        this.storageService.saveToStorage('data', JSON.stringify(data));
        this.storageService.saveToStorage('userId', data.id);
        this.storageService.saveToStorage('speaker', data.speaker);
        return from(this.storageService.saveToStorage('TOKEN', data.token));
      }));
  }

  config() {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.get(`${this.urlServices}/cfg-general-configuration/?type=DW`, options);
  }


  personIdentification(datPerson) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/person-identification/`, datPerson, options);
  }

  personBiometricData(dataBiometric) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/person-bimetric-data/`, dataBiometric, options);
  }

  identifyVerify(reqFinger) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/enrollment/biometric/finger/identify`, reqFinger, options);
  }

  fingerVerify(reqFinger) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/enrollment/biometric/finger/verify`, reqFinger, options);
  }


  validateIne(dataValidateIne) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/enrollment/validate/ine`, dataValidateIne, options);

  }

  validateRenapo(dataValidateRenapo) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/enrollment/validate/renapo`, dataValidateRenapo, options);

  }

  getPendingOrders() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.get(`${this.urlServices}/order/pending `, options);
  }

  createOrder(orderId, body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/order/${orderId}/request/`, body, options);
  }

  confirmOrder(orderId, code, body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.post(`${this.urlServices}/order/${orderId}/confirm/${code}`, body, options);
  }

  uploadFile(formData) {
    const headers = new HttpHeaders({});
    const options = { headers };
    return this.http.post(`${this.urlServices}/document-operation`, formData, options);
  }

  expedeinte(id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.get(`${this.urlServices}/person/branchInfo/?id=${id}`, options);
  }

  updateFingerEnroll(userId) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.put(`${this.urlServices}/user/${userId}`, {
      fingerEnrollment: true
    }, options);
  }

  recoverEnroll(operationId) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const options = { headers };
    return this.http.get(`${this.urlServices}/enrollment/recover/${operationId}`, options);
  }



}
